import CardWithdrawalAccount from './CardWithdrawalAccount';

export default CardWithdrawalAccount;
